import * as React from 'react';
import { DataTable, DateTime } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import DeliveryAddressesSummary from './DeliveryAddressesSummary.js';
import { DeliveryAddressForm } from './DeliveryAddressForm.js';
import { InfoModal } from './InfoModal.js';

const Delivery = ({ cccForm , subscription , onChange , onCancel , onSave , onEditModeChange , onModalClose ,  })=>{
    const { getLabel , getFormattedLabel , locale  } = useIntl();
    const sortedDeliveries = subscription.deliveries.sort((l, r)=>r.date.localeCompare(l.date, 'en', {
            numeric: true,
            usage: 'sort'
        })
    );
    const getRow = (rowIndex)=>sortedDeliveries[rowIndex]
    ;
    return /*#__PURE__*/ React.createElement("div", {
        className: "ccc-deliveries"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, getLabel('account.ccc.detail.deliveryDetails')), /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.ccc.detail.deliveryNote', {
        parseLink: true
    })), (cccForm === null || cccForm === void 0 ? void 0 : cccForm.isInEditMode) ? /*#__PURE__*/ React.createElement(DeliveryAddressForm, {
        onChange: onChange,
        onSave: onSave,
        onCancel: onCancel,
        cccForm: cccForm
    }) : /*#__PURE__*/ React.createElement(DeliveryAddressesSummary, {
        subscription: subscription,
        handleEditClick: ()=>{
            onEditModeChange(true);
        }
    }), /*#__PURE__*/ React.createElement(DataTable, {
        "aria-level": 2,
        caption: getLabel('account.ccc.detail.deliveryHistory'),
        numberOfRows: sortedDeliveries.length
    }, /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "date",
        header: getLabel('common.date')
    }, (rowIndex)=>{
        const row = getRow(rowIndex);
        return row ? /*#__PURE__*/ React.createElement(DateTime, {
            locale: locale,
            dateTime: row.date
        }) : null;
    }), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "id",
        header: getLabel('account.ccc.detail.deliveryHistory.orderNumber')
    }, (rowIndex)=>{
        const row = getRow(rowIndex);
        return (row === null || row === void 0 ? void 0 : row.reference) || getLabel('common.notAvailable');
    }), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "boxes_per_eye_side",
        header: getLabel('account.ccc.detail.deliveryHistory.boxesPerEyeSide')
    }, (rowIndex)=>{
        const row = getRow(rowIndex);
        return (row === null || row === void 0 ? void 0 : row.boxesPerEyeSide) || getLabel('common.notAvailable');
    }), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "status",
        header: getLabel('account.ccc.detail.delivery.status')
    }, (rowIndex)=>{
        const row = getRow(rowIndex);
        return getLabel(`account.ccc.detail.delivery.status.${row === null || row === void 0 ? void 0 : row.status.toLowerCase()}`);
    })), /*#__PURE__*/ React.createElement(InfoModal, {
        isOpen: !!(cccForm === null || cccForm === void 0 ? void 0 : cccForm.isModalOpen),
        onModalClose: onModalClose,
        title: getLabel('account.ccc.detail.infoModal.title'),
        message: getLabel('account.ccc.detail.infoModal.message'),
        okLabel: getLabel('common.actions.ok')
    }));
};

export { Delivery, Delivery as default };
//# sourceMappingURL=Delivery.js.map
